// extracted by mini-css-extract-plugin
export var active = "_kt-e";
export var blink = "_kt-f";
export var dropDownSelector = "_kt-5";
export var dropDownWrapper = "_kt-4";
export var fakeCursor = "_kt-d";
export var fontSizeButton = "_kt-7";
export var formQuillEditor = "_kt-0";
export var pressed = "_kt-g";
export var qlBlank = "_kt-1";
export var textFormattingToolbar = "_kt-2";
export var textFormattingToolbarClosed = "_kt-3";
export var textFormattingToolbarInline = "_kt-6";
export var textToolbarOption = "_kt-8";
export var toolbarCell = "_kt-a";
export var toolbarCellCollapsed = "_kt-b";
export var toolbarOptionHitArea = "_kt-c";
export var toolbarOverflow = "_kt-9";